import { DropzoneFullScreenPremium } from '@components'

import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useUploadAttachments } from '@features/attachments/hooks/useUploadAttachments'
import { useReceiptUploadTracking } from '@views/receipts/hooks/useReceiptUploadTracking'

import { useSegment } from '../../../../hooks'
import { useOrgUsesReceiptsOnly } from '../../../../hooks/useOrgUsesReceiptsOnly'
import { WithTrackingContext } from '../../../../types/withTrackingContext'
import { useGatedUpload } from '../../contexts/ReceiptUploadGateContext'

type ReceiptDropzoneFullScreenProps = WithTrackingContext

export const ReceiptDropzoneFullScreen = ({
  trackingContext,
  receiptUploadSource,
}: ReceiptDropzoneFullScreenProps & { receiptUploadSource: string }): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const orgUsesReceiptsOnly = useOrgUsesReceiptsOnly()

  const trackReceiptUpload = useReceiptUploadTracking({ source: receiptUploadSource })

  const { isUploading, progress, uploadFiles } = useUploadAttachments({
    skipAutoForwardInfoModal: orgUsesReceiptsOnly,
    onSuccess: () => {
      trackReceiptUpload()
      track('File Uploaded (Client)', {
        context: trackingContext,
      })
    },
  })

  const handleDrop = useGatedUpload(uploadFiles)

  return (
    <DropzoneFullScreenPremium
      isUploading={isUploading}
      forceActive={isUploading}
      onDrop={handleDrop}
      uploadingText={t('ds.dropzone.uploading_with_counter', {
        current: progress.current,
        total: progress.total,
      })}
    />
  )
}
